import React from "react";
import "./Breadcrumb.scss";

const Breadcrumb = ({ children }) => {
  return (
    <div className="breadcrumb-main">
      {children.map((child, index) => {
        return (
          <div className="breadcrumb-item" key={index}>
            {child ? <div className="breadcrumb-link">{child}</div> : null}
            {index !== children.length - 1 && children[index + 1] !== null ? (
              <>{" » "}</>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
